import { defineComponent, computed } from "vue";
import { definePropType } from "@types-vue/props";
import TableList from "@pt/views/pt-entry/components/table-list.vue";
import TotalFooter from "./total-footer.vue";
import { t } from "@/lang";
import { isCNSuffix } from "@com/utils/url";
export default defineComponent({
    name: "PackageTable",
    props: {
        grant: {
            type: definePropType(Object),
            required: true
        }
    },
    components: {
        TableList: TableList,
        TotalFooter: TotalFooter
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var list = computed(function() {
            return [
                props.grant
            ];
        });
        var currency = computed(function() {
            return isCNSuffix() ? "CNY" : "USD";
        });
        var columnConfig = [
            {
                prop: "name",
                label: t("playTurbo.payment.grantDialog.packTable.name"),
                align: "left",
                width: 400
            },
            {
                prop: "price",
                slot: "price"
            },
            {
                prop: "count",
                label: t("playTurbo.payment.grantDialog.packTable.count"),
                align: "right",
                params: {
                    innerHTML: function() {
                        return 1;
                    }
                }
            },
            {
                prop: "slot",
                label: "",
                width: 16,
                params: {
                    innerHTML: function() {
                        return "";
                    }
                }
            }, 
        ];
        return {
            columnConfig: columnConfig,
            list: list,
            currency: currency
        };
    }
});
